import { AddressResponse } from '../../../../types/api/common';
import InfoSection from '../../../basic/InfoSection';
import { formatCoordinates, formatAddress } from '../../../../helpers/address';
import { Text } from '@primer/react';
import { LocationIcon, CopyIcon } from '@primer/octicons-react'

interface UserLocationsProps {
    registrationAddress: AddressResponse | undefined;
    userAddress?: AddressResponse | undefined;
    className?: string;
}

const UserLocations: React.FC<UserLocationsProps> = ({
    registrationAddress,
    userAddress,
    className
}) => {

    const registrationCoords = formatCoordinates(registrationAddress?.lat, registrationAddress?.lon);
    const registrationFullAddress = formatAddress(registrationAddress);
    const userFullAddress = userAddress ? formatAddress(userAddress) : null;

    const locationRows = [
        {
            title: 'Геопозиция при регистрации',
            value: `${registrationCoords ? registrationCoords + ', ' : ''}${registrationFullAddress}`,
            isAllowCopy: true
        },
        {
            title: 'Адрес пользователя',
            value: userFullAddress || '',
            isAllowCopy: true
        }
    ];

    return (
        <InfoSection
            className={className}
            title="Адрес и геопозиция"
            rows={locationRows}
            HeaderIcon={LocationIcon}
            CopyIcon={CopyIcon}
            Text={Text}
        />
    );

};

export default UserLocations